/**
 * When the autocomplete field is in manual-entry mode (no dropdown will open), the down arrow
 * + its separator are misleading indicators. Swap both out for no-op components to get the
 * field visually closer to a plain LabeledTextInput while leaving the loading spinner
 * (`LoadingIndicator`) intact.
 */
export const NO_DROPDOWN_COMPONENTS = {
  DropdownIndicator: () => null,
  IndicatorSeparator: () => null,
};
